import React, { Component } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import {TextField,Button,Collapse,Alert,IconButton,Typography,Box} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Serverurl from "./Apiurl";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";




const fieldStyle = {

  borderRadius: "10px",
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
  
    "& fieldset": {
      borderColor: "#d1d5db",
    },
    "&:hover fieldset": {
      borderColor: "#9ca3af",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1976d2",
    },
  },
  "& .MuiInputBase-input": {
    padding: "12px 14px !important",
   
    color: "#000",
  },
};

export default class AddCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cu_id: 0,cu_name: "",cu_emailid: "",cu_phoneno: "",cu_companyname: "",cu_address1: "",cu_shippingaddress: "",cu_gstin: "", cu_state: "",cu_otherinfo: "",redirect: false,btndisabled: false,
      submitbtn: "Save",erropen: false,errormessage: "",pagename: "", fromQuotation: false,
	  };
	  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  componentWillMount() {
    const search = window.location.href;
    const cid = this.getParameterByName("cid", search);
	
	  const from = this.getParameterByName("from", search);

  if (from === "quotation") {
    this.setState({
      fromQuotation: true
    });
  }
  
	 if(localStorage.getItem("GBuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Businesslogin'
          })
		  }
    if (cid) this.getCustomerData(cid);
  }

  getCustomerData = (id) => {
    axios
      .get(Serverurl + "ajaxcustomer.php?action=getall&cu_id=" + id)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          const c = res.data[0];
          this.setState({
            cu_id: c.cu_id,
            cu_name: c.cu_name,
            cu_emailid: c.cu_emailid,
            cu_phoneno: c.cu_phoneno,
            cu_companyname: c.cu_companyname,
            cu_address1: c.cu_address1,
           
            cu_shippingaddress: c.cu_shippingaddress,
            cu_gstin: c.cu_gstin,
            cu_state: c.cu_state,
            cu_otherinfo: c.cu_otherinfo,
          });
        }
      });
  };

  myChangeHandler = (e) => {
     const { name, value } = e.target;
	if (name === "cu_phoneno") {
      this.setState({ [name]: value.replace(/\D/g, ""), emailError: "" });
    } else {
      this.setState({ [name]: value, emailError: "" });
    }
	  if (name === "cu_gstin") {
        this.setState({ bu_gst: value.toUpperCase() }); 
        return;
    }
  };

  handleErrorclose = () => {
    this.setState({ erropen: false, errormessage: "" });
  };

 showError = (msg) => {
  this.setState({
    erropen: true,
    errormessage: msg,
    btndisabled: false,
    submitbtn: "Save",
  }, () => {
    
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
};


  handleSubmit = (e) => {
    e.preventDefault();
 const remail= /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/; 
 const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!this.state.cu_name.trim()) return this.showError("Please Enter Name");
	if (!this.state.cu_companyname.trim()) return this.showError("Please Enter Company Name");
	 if(!remail.test(this.state.cu_emailid)) {return this.showError("Please Enter Valid Emailid")}
	  if (!this.state.cu_phoneno) {return this.showError("Please Enter Phone Number");}
	  else{
		  if(!/^\d{10}$/.test(this.state.cu_phoneno))return this.showError("Please Enter Valid  10 Digits Phone Number");
		  }
	
		
	  

if (!this.state.cu_state.trim()) return this.showError("Please Select the State");

    this.setState({ btndisabled: true, submitbtn: "Processing..." });

    const formData = new FormData();
    formData.append("action", "insertorupdate");
    formData.append("cu_id", this.state.cu_id);
    formData.append("cu_name", this.state.cu_name);
    formData.append("cu_emailid", this.state.cu_emailid);
    formData.append("cu_phoneno", this.state.cu_phoneno);
    formData.append("cu_companyname", this.state.cu_companyname);
    formData.append("cu_address1", this.state.cu_address1);

    formData.append("cu_shippingaddress", this.state.cu_shippingaddress);
    formData.append("cu_gstin", this.state.cu_gstin);
    formData.append("cu_state", this.state.cu_state);
    formData.append("cu_otherinfo", this.state.cu_otherinfo);
    formData.append("userid",localStorage.getItem("GBuserid"));
 formData.append("cu_bu_id",localStorage.getItem("GBuserid"));
   axios.post(Serverurl + "ajaxcustomer.php", formData).then((res) => {

    console.log("API Response:", res.data);

    const cid = Array.isArray(res.data)
        ? res.data[0]?.cu_id
        : res.data?.cu_id || res.data;

    console.log("Customer ID:", cid);

    if (cid === -1 || cid === "-1") {
        this.showError("Phone number already exists");
        return;
    }

   if (cid && Number(cid) > 0) {

    if (this.props.quotationMode || this.props.invoiceMode) {

        const customer = {
            cu_id: cid,
            cu_name: this.state.cu_name,
            cu_companyname: this.state.cu_companyname,
            cu_phoneno: this.state.cu_phoneno
        };

        this.props.onCustomerAdded(customer);

    } else {

        this.setState({
            redirect: true,
            pagename: "/Customerlist"
        });

    }

} else {

    this.showError("Error saving customer");

}

});
  };

  render() {
	  const states = [
      "Andhra Pradesh","Arunachal Pradesh","Assam","Bihar","Chhattisgarh","Goa","Gujarat",
      "Haryana","Himachal Pradesh","Jharkhand","Karnataka","Kerala","Madhya Pradesh",
      "Maharashtra","Manipur","Meghalaya","Mizoram","Nagaland","Odisha","Punjab",
      "Rajasthan","Sikkim","Tamil Nadu","Telangana","Tripura","Uttar Pradesh",
      "Uttarakhand","West Bengal"
    ];
    if (this.state.redirect) {
      return <Navigate to={this.state.pagename} />;
    }

    return (
		<React.Fragment>
  
  <div className="formmain">
    <Box sx={{ display: "flex", alignItems: "center", mb: 3,marginBottom:'10px' }}>
  {!this.props.quotationMode && (
        <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>
  )}

  <Typography variant="h4">Customer</Typography>
</Box>
		{/* <p className="backbtn">
      <a href="/Customerlist">Back</a>
		</p>*/}
        <Collapse in={this.state.erropen}>
          <Alert
            severity="error"
            action={
              <IconButton size="small" onClick={this.handleErrorclose}>
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {this.state.errormessage}
          </Alert>
        </Collapse>

        <form onSubmit={this.handleSubmit}>
			{/*<p><span className="validation">*</span>Customer Name</p>*/}
     
<p>
  <TextField
  label="Customer Name"
    name="cu_name"
    placeholder="Customer Name"
    value={this.state.cu_name}
    inputProps={{ maxLength: 150, tabIndex: 1 }}
    onChange={this.myChangeHandler}
	InputLabelProps={{ shrink: true }}
    fullWidth
    margin="normal"
    sx={fieldStyle}
  />
</p>
{/* <p><span className="validation">*</span>Company Name</p>*/}
          <p><TextField
		  label="Company Name"
            name="cu_companyname"
			 placeholder="Company Name"
            value={this.state.cu_companyname}
			inputProps={{ maxLength: 150,tabIndex: 2 }}
            onChange={this.myChangeHandler}
			InputLabelProps={{ shrink: true }}
            fullWidth
            margin="normal"
			 sx={fieldStyle}
          /></p>
		  
		  {/* <p>Email</p>*/}
          <p><TextField
		  label="Email"
            name="cu_emailid"
			 placeholder="Email"
            value={this.state.cu_emailid}
			inputProps={{ maxLength: 150,tabIndex: 3 }}
            onChange={this.myChangeHandler}
			InputLabelProps={{ shrink: true }}
            fullWidth
            margin="normal"
			sx={fieldStyle}
          /></p>
          
		  {/*<p><span className="validation">*</span>Phone</p>*/}
          <p><TextField
		  label="Phone"
            name="cu_phoneno"
			 placeholder="Phone"
            value={this.state.cu_phoneno}
			inputProps={{ maxLength: 10,tabIndex: 4 }}
            onChange={this.myChangeHandler}
			InputLabelProps={{ shrink: true }}
            fullWidth
            margin="normal"
			sx={fieldStyle}
          /></p>

		  {/* <p>Address</p> */}
         <p> <TextField
		 label="Address"
            name="cu_address1"
			 placeholder="Address"
            value={this.state.cu_address1}
            onChange={this.myChangeHandler}
			InputLabelProps={{ shrink: true }}
            fullWidth
			 multiline
			  rows={2}
            margin="normal"
			inputProps={{ tabIndex: 5 }}
			sx={fieldStyle}
          /></p>
		  
        
		{/* <p>Otherinfo</p>*/}
         <p> <TextField
		 label="Otherinfo"
            name="cu_otherinfo"
			placeholder="Otherinfo"
            value={this.state.cu_otherinfo}
			onChange={this.myChangeHandler}
			InputLabelProps={{ shrink: true }}
			inputProps={{ maxLength: 150,tabIndex: 6 }}
            fullWidth
            margin="normal"
			
			sx={fieldStyle}
          /></p>
		 
		 {/* <p>GSTIN</p>*/}
          <p><TextField name="cu_gstin" label="GSTIN" placeholder="GSTIN" value={this.state.cu_gstin} inputProps={{ maxLength: 15, tabIndex: 7  }}onChange={this.myChangeHandler} fullWidth   margin="normal" sx={fieldStyle} InputLabelProps={{ shrink: true }}/></p>
 {/*<p><span className="validation">*</span>State</p>*/}
        <p> <TextField select label="State" name="cu_state" placeholder="State" value={this.state.cu_state} onChange={this.myChangeHandler} fullWidth   margin="normal" sx={fieldStyle} SelectProps={{ native: true }} InputLabelProps={{ shrink: true }}>
            <option value="">Select State</option>
            {states.map((state) => <option key={state} value={state}>{state}</option>)}
          </TextField></p>
 <Box sx={{ mt: 3, mb: 1 }}>
  <Typography variant="h6" fontWeight={500}>
    Shipping Address
  </Typography>
</Box>
{/*<p>Address</p>*/}
<p><TextField
  name="cu_shippingaddress"
  placeholder="Address"
  value={this.state.cu_shippingaddress}
  onChange={this.myChangeHandler}
  fullWidth
  margin="normal"
  sx={fieldStyle}
  multiline
  rows={2}
/></p>
 <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button
              type="submit"
              variant="contained"
              disabled={this.state.btndisabled} className="primartybtn"
			  sx={{
   
    borderRadius: "20px",
    minWidth: "110px",
  }}
            >
              {this.state.submitbtn}
            </Button>
          </Box>
        </form>
      </div>
	  	</React.Fragment>
    );
  }
}
